interface SwipeOptions {
    minDistance?: number
    maxDuration?: number
    directionRatio?: number
}

export function useHorizontalSwipe(onSwipe: (direction: -1 | 1) => void, options: SwipeOptions = {}) {
    const minDistance = options.minDistance ?? 46
    const maxDuration = options.maxDuration ?? 1100
    const directionRatio = options.directionRatio ?? 1.25
    let startX = 0
    let startY = 0
    let startedAt = 0
    let tracking = false

    function onTouchStart(event: TouchEvent) {
        if (event.touches.length !== 1) {
            tracking = false
            return
        }
        const touch = event.touches[0]
        const target = event.target instanceof Element ? event.target : undefined
        if (!touch || target?.closest('input, textarea, select, [data-swipe-ignore]')) {
            tracking = false
            return
        }
        startX = touch.clientX
        startY = touch.clientY
        startedAt = performance.now()
        tracking = true
    }

    function onTouchEnd(event: TouchEvent) {
        if (!tracking) { return }
        tracking = false
        const touch = event.changedTouches[0]
        if (!touch || performance.now() - startedAt > maxDuration) { return }
        const deltaX = touch.clientX - startX
        const deltaY = touch.clientY - startY
        if (Math.abs(deltaX) < minDistance || Math.abs(deltaX) < Math.abs(deltaY) * directionRatio) { return }
        if (event.cancelable) { event.preventDefault() }
        onSwipe(deltaX < 0 ? 1 : -1)
    }

    function onTouchCancel() {
        tracking = false
    }

    return { onTouchStart, onTouchEnd, onTouchCancel }
}
